import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

import {Icon} from '@shared/Components';

import {getLabel} from '../../Config/labels';
import {TPlace} from '../../Definitions';
import OpenIndicator from './OpenIndicator';
import TypeIcon from '../TypeIcon';
import {shortWeekdays} from '../../Utils';

const getRoutePlannerUrl = (placeId: string, placeName: string) =>
    `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(placeName)}&destination_place_id=${placeId}`;

const mapTypes = (types: string[] = []) => types
    .map(type => getLabel(type))
    .filter(i => i)
    .slice(0, 2)
    .join(', ');

type TPlaceCardProps = {
    place: TPlace;
    className?: string;
    isActive?: boolean;
    toggle?: () => void;
};
export default ({className, isActive, toggle, place}: TPlaceCardProps) => {
    const [isOverlayed, setIsOverlayed] = React.useState(false);
    const toggleOverlay = () => setIsOverlayed(current => !current);
    const hasOverlayContent = Boolean(place.opening_hours?.weekday_text);

    return (
        <div className={classNames(
            styles.card,
            isActive && styles.isActive,
            className
        )}>
            <div className={styles.richMedia}>
                {
                    (place.photos?.length)
                        ? <img src={place.photos[0].getUrl({})}/>
                        : <></>
                }
                {
                    place.business_status && (
                        <OpenIndicator
                            businessStatus={place.business_status}
                            isOpen={place.opening_hours?.isOpen()}
                            onClick={hasOverlayContent ? toggleOverlay : undefined}
                        />
                    )
                }
                {
                    isOverlayed && hasOverlayContent && (
                        <div className={styles.overlay}>
                            <div
                                className={styles.toggler}
                                onClick={toggleOverlay}
                            >
                                <Icon
                                    name="Close"
                                    className={styles.icon}
                                />
                            </div>
                            <div className={styles.rows}>
                                {place.opening_hours?.weekday_text?.map((row, index) => (
                                    <span key={index}>{shortWeekdays(row)}</span>
                                ))}
                            </div>
                        </div>
                    )
                }
                {
                    place.poi?.hasWertkarte &&
                        <div className={styles.wertkarte}></div>
                }
            </div>
            <div className={styles.content}>
                {
                    place.icon &&
                        <TypeIcon
                            icon={place.icon}
                            className={styles.icon}
                        />
                }
                <div className={styles.header}>
                    <div className={styles.title}>
                        {
                            (place.types && place.types.length > 0) && (
                                <div className={styles.types}>
                                    {mapTypes(place.types)}
                                </div>
                            )
                        }
                        <div className={styles.name}>
                            {place.name}
                        </div>
                    </div>
                </div>
                <div className={styles.supportingText}>
                    <div>
                        {
                            place.vicinity?.split(',').map((part, index) =>
                                <span key={index}>{part}</span>
                            )
                        }
                        {
                            place.formatted_phone_number && (
                                <a href={`tel:${place.formatted_phone_number}`}>
                                    {place.formatted_phone_number}
                                </a>
                            )
                        }
                    </div>
                    <div>
                        {
                            toggle && (
                                <div className={styles.actions}>
                                    <div className={classNames(place.poi?.isFairTrade && styles.isFairTrade)}></div>
                                    <div
                                        onClick={toggle}
                                        className={styles.action}
                                    >
                                        <Icon name="RoadMap"/>
                                        <span>Auf der Karte zeigen</span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className={styles.divider}></div>
                <div className={styles.supplementalActions}>
                    {
                        place.url && place.place_id && (
                            <div>
                                <a href={getRoutePlannerUrl(place.place_id, place.name)} target="_blank">Route planen</a>
                            </div>
                        )
                    }
                    {
                        place.website && (
                            <div>
                                <a href={place.website} target="_blank">Website besuchen</a>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
